export const pages = {
  CONTACTS: "contacts",
  COMPANIES: "companies",
  DEALS: "deals",
  LEADS: "leads",
  ANALYTICS: "analytics",
  TASKS: "tasks",
  SETTINGS: "settings",
  ONBOARDING: "onboarding",
  MANAGE_INTEGRATIONS: "manage-integration",
  MANAGE_INTEGRATION_CREDENTIALS: "integration-details",
  MAILBOX_SIGNATURE: "mailbox-signature",
};

export const references = {
  CONTACTS: "Contact",
  COMPANIES: "Company",
  DEALS: "Deal",
  ACTIONS: "Action",
  TASKS: "Task",
  LEADS: "Lead",
  MEETING: "Meeting",
  CALL_LOG: "call_log",
  CRM_TASKS: "crm_tasks",
  TICKETS: "tickets",
};

export const entityDetailsRoute = {
  COMPANY: "companies",
  DEAL: "deals",
  CONTACT: "contacts",
  LEAD: "leads",
  ACTION: "actions",
};

export const entityViews = {
  CONTACT_VIEW: "contact_view",
  COMPANY_VIEW: "company_view",
  LEAD_VIEW: "lead_view",
  DEAL_VIEW: "deal_view",
  MEETING: "meeting",
  CALL_LOG_VIEW: "call_log_view",
  CRM_TASKS_VIEW: "crm_tasks_view",
  TICKETS_VIEW: "tickets_view",
};
